import { render, staticRenderFns } from "./Ajuda.vue?vue&type=template&id=6cdc013c&scoped=true&"
import script from "./Ajuda.vue?vue&type=script&lang=js&"
export * from "./Ajuda.vue?vue&type=script&lang=js&"
import style0 from "./Ajuda.vue?vue&type=style&index=0&id=6cdc013c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc013c",
  null
  
)

export default component.exports